import { useState, useEffect } from 'react';
import Api from 'entities/helpers/api';

/**
 * Fetches real contact lists (user_list type) from the contacts lists API.
 * Used by cadence, prospect plan, and bulk message creation pages for recipient selection.
 */
const useLists = () => {
  const [lists, setLists] = useState([]);
  useEffect(() => {
    Api.CONTACTS.LISTS.get({ params: { limit: 200, type: 'user_list' } })
      .then((resp) => {
        const items = (resp?.items || [])
          .filter((item) => item.type === 'user_list' || item.type === 1)
          .map((item) => ({
            label: item.name,
            value: String(item.id),
            count: item.contact_count || 0,
          }));
        setLists(items);
      })
      .catch(() => setLists([]));
  }, []);
  return lists;
};

export default useLists;
